import { render, staticRenderFns } from "./ShopStorePayKuaifu.vue?vue&type=template&id=54aa3bb4&scoped=true&"
import script from "./ShopStorePayKuaifu.vue?vue&type=script&lang=js&"
export * from "./ShopStorePayKuaifu.vue?vue&type=script&lang=js&"
import style0 from "./ShopStorePayKuaifu.vue?vue&type=style&index=0&id=54aa3bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa3bb4",
  null
  
)

export default component.exports